import { Dialog as ShadcnDialog } from '@shadcn/ui/dialog';
import React from 'react';

export function Dialog({ ...props }: IDialogProps) {
  return <ShadcnDialog {...props} />;
}

export {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@shadcn/ui/dialog';

export type IDialogProps = React.ComponentProps<typeof ShadcnDialog>;
